/** HTML date input (`YYYY-MM-DD`) 용 — DB/ISO/로컬 문자열을 가능한 한 정규화 */
export function dateToHtmlInput(value: unknown): string {
  if (value == null || value === '') return '';
  if (value instanceof Date) {
    if (isNaN(value.getTime())) return '';
    const yyyy = String(value.getFullYear());
    const mm = String(value.getMonth() + 1).padStart(2, '0');
    const dd = String(value.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }
  const s = String(value).trim();
  if (!s) return '';
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);

  // entity/profile API — en-GB "DD/MM/YYYY" (new Date()로는 파싱 불가)
  const gbSlash = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (gbSlash) {
    const [, day, month, year] = gbSlash;
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  }
  const gbDash = s.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/);
  if (gbDash) {
    const [, day, month, year] = gbDash;
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  }

  const d = new Date(s);
  if (!isNaN(d.getTime())) {
    const yyyy = String(d.getFullYear());
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }
  return '';
}
